const OPEN_DATA_LABELS = {
    sq: {
        menu: 'Open Data',
        pageTitle: 'Open Data',
        pageLead: 'Zgjedhni një kategori në të djathtë dhe shkarkoni të dhënat e bizneseve në format Excel ose JSON.',
        menuHeading: 'Kategoritë',
        warning: 'Shkarkimi mund të zgjasë disa sekonda. Ju lutem mos e largoni faqen deri në përfundim.',
        download: 'Shkarko',
        downloadExcel: 'Shkarko Excel',
        downloadJson: 'Shkarko JSON (ZIP)',
        cancel: 'Mbyll',
        downloading: 'Po përgatitet dhe shkarkohet skedari…',
        downloadingHint: 'Mos e largoni faqen.',
        done: 'Skedari u shkarkua me sukses.',
        downloadAgain: 'Shkarko përsëri',
        error: 'Ndodhi një gabim gjatë shkarkimit. Provoni përsëri.',
        blocked: 'Serveri i shkarkimit nuk u arrit (mund të jetë i bllokuar nga shfletuesi për shkak të http/https ose CORS). Kontaktoni administratorin.',
        empty: 'Nuk u kthye asnjë biznes nga serveri.',
        options: {
            teGjitha: {
                label: 'Lista e Bizneseve të Regjistruara',
                title: 'Lista e Bizneseve të Regjistruara',
                desc: 'Shkarkoni të dhënat e të gjitha bizneseve të regjistruara në format Excel ose JSON.',
            },
            shuar: {
                label: 'Lista e Bizneseve të Shuara',
                title: 'Lista e Bizneseve të Shuara',
                desc: 'Shkarkoni të dhënat e bizneseve që janë shuar në format Excel ose JSON.',
            },
            huaj: {
                label: 'Lista e Bizneseve me Pronarë të Huaj',
                title: 'Lista e Bizneseve me Pronarë të Huaj',
                desc: 'Shkarkoni të dhënat e bizneseve me pronësi të huaj në format Excel ose JSON.',
            },
            femra: {
                label: 'Lista e Bizneseve me të Paktën Një Pronare Grua/Vajzë',
                title: 'Lista e Bizneseve me të Paktën Një Pronare Grua/Vajzë',
                desc: 'Shkarkoni të dhënat e bizneseve me të paktën një pronare Grua/Vajzë në format Excel ose JSON.',
            },
        },
        stats: {
            sectionHeading: 'Statistika',
            huajTitle: 'Bizneset me pronarë të huaj',
            huajChart: 'Bizneset sipas shtetit të pronarit të huaj',
            femraTitle: 'Bizneset me pronare Grua/Vajzë',
            femraChart: 'Bizneset sipas sektorëve',
            top20Title: 'Top 20 Aktivitetet',
            top20Chart: 'Bizneset sipas aktivitetit kryesor',
            numri: 'Numri i bizneseve',
            totali: 'Totali i përgjithshëm',
            njesite: 'Totali sipas njësive',
            noData: 'Nuk ka të dhëna',
            fYear: 'Viti',
            fStatus: 'Statusi',
            fKomuna: 'Komuna',
            fShteti: 'Shteti',
            fSektori: 'Sektori',
            fLloji: 'Lloji i biznesit',
            fAktiviteti: 'Aktiviteti',
            statusAktive: 'Aktive',
            statusShuar: 'Shuar',
            statusPasive: 'Pasive',
        },
    },
    en: {
        menu: 'Open Data',
        pageTitle: 'Open Data',
        pageLead: 'Choose a category on the right and download the business data as an Excel or JSON file.',
        menuHeading: 'Categories',
        warning: 'The download may take several seconds. Please do not leave the page until it finishes.',
        download: 'Download',
        downloadExcel: 'Download Excel',
        downloadJson: 'Download JSON (ZIP)',
        cancel: 'Close',
        downloading: 'Preparing and downloading the file…',
        downloadingHint: 'Please keep this page open.',
        done: 'The file was downloaded successfully.',
        downloadAgain: 'Download again',
        error: 'An error occurred during the download. Please try again.',
        blocked: 'Could not reach the export server (it may be blocked by the browser due to http/https or CORS). Please contact the administrator.',
        empty: 'The server returned no businesses.',
        options: {
            teGjitha: {
                label: 'List of Registered Businesses',
                title: 'List of Registered Businesses',
                desc: 'Download the data of all registered businesses as an Excel or JSON file.',
            },
            shuar: {
                label: 'List of Closed Businesses',
                title: 'List of Closed Businesses',
                desc: 'Download the data of businesses that have been closed as an Excel or JSON file.',
            },
            huaj: {
                label: 'List of Businesses with Foreign Owners',
                title: 'List of Businesses with Foreign Owners',
                desc: 'Download the data of foreign-owned businesses as an Excel or JSON file.',
            },
            femra: {
                label: 'List of Businesses with at Least One Female Owner',
                title: 'List of Businesses with at Least One Female Owner',
                desc: 'Download the data of businesses with at least one female owner as an Excel or JSON file.',
            },
        },
        stats: {
            sectionHeading: 'Statistics',
            huajTitle: 'Businesses with foreign owners',
            huajChart: 'Businesses by foreign owner country',
            femraTitle: 'Businesses with female owners',
            femraChart: 'Businesses by sector',
            top20Title: 'Top 20 Activities',
            top20Chart: 'Businesses by main activity',
            numri: 'Number of businesses',
            totali: 'Grand total',
            njesite: 'Total by units',
            noData: 'No data',
            fYear: 'Year',
            fStatus: 'Status',
            fKomuna: 'Municipality',
            fShteti: 'Country',
            fSektori: 'Sector',
            fLloji: 'Business type',
            fAktiviteti: 'Activity',
            statusAktive: 'Active',
            statusShuar: 'Closed',
            statusPasive: 'Passive',
        },
    },
    sr: {
        menu: 'Open Data',
        pageTitle: 'Open Data',
        pageLead: 'Izaberite kategoriju sa desne strane i preuzmite podatke o biznisima u Excel ili JSON datoteku.',
        menuHeading: 'Kategorije',
        warning: 'Preuzimanje može potrajati nekoliko sekundi. Molimo ne napuštajte stranicu dok se ne završi.',
        download: 'Preuzmi',
        downloadExcel: 'Preuzmi Excel',
        downloadJson: 'Preuzmi JSON (ZIP)',
        cancel: 'Zatvori',
        downloading: 'Priprema i preuzimanje datoteke…',
        downloadingHint: 'Ne napuštajte ovu stranicu.',
        done: 'Datoteka je uspešno preuzeta.',
        downloadAgain: 'Preuzmi ponovo',
        error: 'Došlo je do greške prilikom preuzimanja. Pokušajte ponovo.',
        blocked: 'Server za preuzimanje nije dostupan (možda ga blokira pregledač zbog http/https ili CORS). Kontaktirajte administratora.',
        empty: 'Server nije vratio nijedan biznis.',
        options: {
            teGjitha: {
                label: 'Spisak registrovanih biznisa',
                title: 'Spisak registrovanih biznisa',
                desc: 'Preuzmite podatke svih registrovanih biznisa u Excel ili JSON datoteku.',
            },
            shuar: {
                label: 'Spisak ugašenih biznisa',
                title: 'Spisak ugašenih biznisa',
                desc: 'Preuzmite podatke biznisa koji su ugašeni u Excel ili JSON datoteku.',
            },
            huaj: {
                label: 'Spisak biznisa sa stranim vlasnicima',
                title: 'Spisak biznisa sa stranim vlasnicima',
                desc: 'Preuzmite podatke biznisa u stranom vlasništvu u Excel ili JSON datoteku.',
            },
            femra: {
                label: 'Spisak biznisa sa najmanje jednom vlasnicom',
                title: 'Spisak biznisa sa najmanje jednom vlasnicom',
                desc: 'Preuzmite podatke biznisa sa najmanje jednom vlasnicom u Excel ili JSON datoteku.',
            },
        },
        stats: {
            sectionHeading: 'Statistika',
            huajTitle: 'Biznisi sa stranim vlasnicima',
            huajChart: 'Biznisi prema zemlji stranog vlasnika',
            femraTitle: 'Biznisi sa vlasnicama ženama',
            femraChart: 'Biznisi prema sektorima',
            top20Title: 'Top 20 delatnosti',
            top20Chart: 'Biznisi prema glavnoj delatnosti',
            numri: 'Broj biznisa',
            totali: 'Ukupan zbir',
            njesite: 'Ukupno po jedinicama',
            noData: 'Nema podataka',
            fYear: 'Godina',
            fStatus: 'Status',
            fKomuna: 'Opština',
            fShteti: 'Država',
            fSektori: 'Sektor',
            fLloji: 'Vrsta biznisa',
            fAktiviteti: 'Delatnost',
            statusAktive: 'Aktivan',
            statusShuar: 'Ugašen',
            statusPasive: 'Pasivan',
        },
    },
};

export default function getOpenDataLabels(locale) {
    return OPEN_DATA_LABELS[locale] || OPEN_DATA_LABELS.sq;
}
